import { BerechnungsartDurchschnitt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/BerechnungsartDurchschnitt';
import { BerechnungsartExakt } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/BerechnungsartExakt';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function StundenpensumMonat() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <>
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.label',
        )}
        item={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.monat',
        )}
      />

      {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat ===
        'durchschnitt' && <BerechnungsartDurchschnitt />}
      {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.berechnungsartMonat ===
        'exakt' && <BerechnungsartExakt />}
    </>
  );
}
